import Layout from "./Layout"
import Header from "./Header"
import Projects from "./Projects"
import Skills from "./Skills";
import Footer from "./Footer";


function App() {
  return (
    <Layout>
      <Header></Header>
      <Projects></Projects>
      <Skills></Skills>
      <Footer></Footer>
    </Layout>
  );
}

export default App;
